import React, { useContext, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { responseHandler } from '../components/utility/Utility';
import '../assets/css/views/settings.css'; // We can reuse the same styles

export default function Pricing() {
    const { getJwtToken, userProfile } = useContext(AuthContext);
    const navigate = useNavigate();

    // TEMPORARILY DISABLED - During free unlimited access period, redirect everyone to dashboard
    // No need to check billing status since everyone gets free access
    useEffect(() => {
        if (userProfile?.store) {
            navigate('/app/loyalty/dashboard');
        }
    }, [userProfile, navigate]);

    const plans = [
        { name: 'Free', price: 0, orders: 'Up to 100' },
        { name: 'Starter', price: 19.99, orders: 'Up to 500', overcharge: '0.15' },
        { name: 'Grow', price: 49.99, orders: 'Up to 2,500', overcharge: '0.10' },
        { name: 'Enterprise', price: 99.99, orders: 'Unlimited', overcharge: null }
    ];

    const getTrialDaysRemaining = () => {
        if (userProfile?.store?.billing?.status === 'trialing' && userProfile?.store?.billing?.trialEndsAt) {
            const remainingTime = new Date(userProfile.store.billing.trialEndsAt).getTime() - Date.now();
            if (remainingTime > 0) {
                return Math.ceil(remainingTime / (1000 * 60 * 60 * 24));
            }
        }
        return null;
    };

    const trialDaysRemaining = getTrialDaysRemaining();

    const selectPlan = async (plan) => {
        try {
            const token = await getJwtToken();
            if (plan.name === 'Free') {
                await axios.put(
                    'https://api.amplifyloyalty.com/app/billing/plan',
                    { plan: plan.name.toLowerCase() },
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                window.location.reload();
            } else {
                const res = await axios.post(
                    'https://api.amplifyloyalty.com/app/billing/subscribe',
                    { name: plan.name, price: plan.price },
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                if (res.data) {
                    // Fire Facebook Pixel Purchase event
                    if (window.fbq) {
                        window.fbq('track', 'Purchase', {
                            value: plan.price,
                            currency: 'USD'
                        });
                    }
                    // Redirect to Shopify's confirmation URL
                    window.location.href = res.data;
                }
            }
        } catch (err) {
            responseHandler(err, "error", "Could not initiate subscription. Please try again later.");
            console.error(err);
        }
    };
    
    // TEMPORARILY DISABLED - Plan selection page
    // This page is not needed during unlimited free access period
    // Users with forever_free status are automatically redirected away in useEffect above
    
    return(
        <div className="main">
            <div className="settings">
                <div className="settings__billing-header">
                    <h3 className="settings__heading">Welcome!</h3>
                    <p className="settings__sub-heading">
                        Redirecting you to your dashboard...
                    </p>
                </div>
            </div>
        </div>
    )
    
    /* PRICING UI - PRESERVED FOR FUTURE RE-ENABLEMENT
    return(
        <div className="main">
            <div className="settings">
                <div className="settings__billing-header">
                    <h3 className="settings__heading">Choose Your Plan</h3>
                    <p className="settings__sub-heading">
                        {trialDaysRemaining !== null
                            ? `Your 60-day trial has begun! Select a plan below to continue. You have ${trialDaysRemaining} days remaining. You will NOT be billed until your trial is over.`
                            : "Please select a plan to continue."}
                    </p>
                </div>
                <div className="settings__plans-container">
                    <div className="settings__plans">
                        {plans.map(plan => {
                            const isCurrentPlan = userProfile?.store?.billing?.plan === plan.name.toLowerCase();
                            return (
                                <div key={plan.name} className={`settings__plan ${isCurrentPlan ? 'settings__plan--current' : ''}`}>
                                    {isCurrentPlan && <div className="settings__plan-current-badge">Current</div>}
                                    <div className="settings__plan-header">
                                        <h4 className="settings__plan-name">{plan.name}</h4>
                                        <div className="settings__plan-price">
                                            ${plan.price}
                                            <span>/mo</span>
                                        </div>
                                    </div>
                                    <ul className="settings__plan-features">
                                        <li className="settings__plan-feature">
                                            <i className="fa-solid fa-check settings__plan-icon"></i> {plan.orders} Orders
                                        </li>
                                        {plan.overcharge && (
                                            <li className="settings__plan-feature">
                                                <i className="fa-solid fa-check settings__plan-icon"></i> ${plan.overcharge} per extra order
                                            </li>
                                        )}
                                        <li className="settings__plan-feature">
                                            <i className="fa-solid fa-check settings__plan-icon"></i> All Features Included
                                        </li>
                                    </ul>
                                    <div className="settings__plan-button-container">
                                        <button 
                                            className="settings__plan-button gradient btn"
                                            onClick={() => selectPlan(plan)}
                                            disabled={isCurrentPlan}
                                        >
                                            {isCurrentPlan ? 'Current Plan' : 'Select Plan'}
                                        </button>
                                    </div>
                                </div>
                            )})}
                    </div>
                </div>
            </div>
        </div>
    )
    */
} 